import filter from './filter';

export default {
  ...filter,
};



// WEBPACK FOOTER //
// ./src/filter/index.js